import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { ForgetPinUseCase } from './ForgetPinUseCase';
import { GetPromotionsUseCase } from './GetPromotionsUseCase';
import { GetRewindUseCase } from './GetRewindsUseCase';
import { GetByPopcornUrlUseCase } from './GetByPopcornUrlUseCase';

export const initializePopcornUseCases = (container: Container) => {
    container.register(DI.USECASES.IForgetPinUseCase, {
        useClass: ForgetPinUseCase,
    });
    container.register(DI.USECASES.IGetPromotionsUseCase, {
        useClass: GetPromotionsUseCase,
    });
    container.register(DI.USECASES.IGetRewindsUseCase, {
        useClass: GetRewindUseCase,
    });
    container.register(DI.USECASES.IGetByPopcornUrlUseCase, {
        useClass: GetByPopcornUrlUseCase,
    });
};
